import './TrangChuLayoutMobile.scss'
import { Banner } from '../../component/Banner'
import { ChuChayMobile } from '../../component/ChuChayMobile'
import Sidebar from './Sidebar/Sidebar'
import { TheThao } from './TheThao'
import { Casino } from './Casino'
import { NoHu } from './NoHu'
import { BanCa } from './BanCa'
import { DaGa } from './DaGa'
import { useState } from 'react'
import { Hot } from './Hot'
import { XoSo } from './XoSo'

function TrangChuLayoutMobile () {
  const [tab, settab] = useState('ร้อน')
  return (
    <div className='home_mobile'>
      <div className='top_banner_mobile'>
        <Banner />
      </div>
      <ChuChayMobile />
      <div className='home_globy'>
        <Sidebar tab={tab} settab={settab} />
        {tab === 'ร้อน' && <Hot />}
        {tab === 'กีฬา' && <TheThao />}
        {tab === 'คาสิโน' && <Casino />}
        {tab === 'ลอตเตอรี่' && <NoHu />}
        {tab === 'เกมยิงปลา' && <BanCa />}
        {tab === 'ไก่เกม' && <DaGa />}
        {tab === 'หวย' && <XoSo />}
      </div>
      <div className='footer_vh'></div>
    </div>
  )
}

export default TrangChuLayoutMobile
